//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Item from './_expression_item.vue'
export default {
    props: {
        show: Boolean,
        is_consultant_user: Boolean,
        frequent_expressions: Array
    },
    components: {
        Item
    },
    data () {
        return {
            enable_scroll: true
        }
    }
}
